// extracted by mini-css-extract-plugin
module.exports = {"errorSummary":"_shipping-information-ErrorSummary-module--error-summary--22qiD"};